import {useMutation} from '@tanstack/react-query';
import {TypeLocalNameEnum} from 'domain/usecases';
import {MIN_DISTANCE_IN_KM_EXAM} from 'presentation/modules/booking/exam/ui/components/ExamSearchBar/hooks/useExamSearchBar/constants';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages';
import {getExamUnits} from '../../services/getExamUnits';

function useGetExamUnitsMutation() {
	const {
		SEARCH_PARAMS: {localityDistance},
	} = useQueryParams();
	const {
		isManualLocation,
		districtName,
		specialtyCode,
		ufCode,
		cityName,
		coordinates,
		typeLocalName,
		citiesNames,
	} = useBookingStore(state => state.bookingData);
	const isUsingGeolocation = !isManualLocation;

	const distance = () => {
		if (isUsingGeolocation) {
			return localityDistance || MIN_DISTANCE_IN_KM_EXAM;
		}
		return !localityDistance && districtName ? undefined : localityDistance;
	};

	const unitParams = {
		examType: specialtyCode,
		stateCode: isUsingGeolocation ? undefined : ufCode?.toUpperCase(),
		cityName: isUsingGeolocation ? coordinates : cityName?.toUpperCase(),
		distance: distance(),
		typeLocalName: typeLocalName || TypeLocalNameEnum.CIDADE,
		districtNames: districtName && !localityDistance ? districtName : undefined,
		citiesNames: citiesNames && !localityDistance ? citiesNames : undefined,
	};

	return useMutation({
		mutationFn: async ({signal}: {signal?: AbortSignal}) =>
			getExamUnits({
				signal,
				...unitParams,
			}),
	});
}

export {useGetExamUnitsMutation};
